import {useRef, useEffect} from 'react';

export const usePrevious = <T = any>(value: T): T => {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export default usePrevious;
